module.exports = __webpack_public_path__ + "img/fauteuil-25.97ab2835.jpg";